<!-- Utilizamos el componente nz-tag de Ant Design para mostrar las etiquetas -->
<nz-tag [nzColor]="color">
  {{ text }}
</nz-tag>
